import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
import { Icon } from '@iconify/react';
// Updated candidatura data
const candidaturaData = {
  id: '2025010553681',
  bando: 'Bando 1 - Nuove Opere',
  settore: 'MUSICA',
  status: 'In Valutazione',
  dataInvio: '15/03/2025',
  soggettoProponente: 'Associazione Culturale Test Nuove Opere',
  contributoRichiesto: 40000,
  costoTotale: 50000,
  image: 'https://cdn.bandiperchicrea.it/bandi/Nuove%20Opere-min.jpg'
};
const timelineSteps = [{
  number: 1,
  label: 'REGISTRAZIONE',
  completed: true
}, {
  number: 2,
  label: 'CANDIDATURA IN BOZZA',
  completed: true
}, {
  number: 3,
  label: 'CANDIDATURA INVIATA',
  completed: true
}, {
  number: 4,
  label: 'IN VALUTAZIONE',
  completed: true,
  active: true
}, {
  number: 5,
  label: 'ESITO VALUTAZIONE',
  sublabel: 'CONTRIBUTO NON ASSEGNATO',
  completed: false
}];
// Updated cronoprogramma data
const cronoprogramma = [{
  attivita: 'Attività di produzione della nuova opera',
  da: '15/02/2025',
  a: '30/09/2025'
}, {
  attivita: 'Pubblicazione o presentazione al pubblico della nuova opera',
  da: '01/10/2025',
  a: '15/10/2025'
}, {
  attivita: 'Attività di comunicazione e promozione',
  da: '01/09/2025',
  a: '31/10/2025'
}];
// Updated voci di costo data structure for the new detailed view
const vociDiCostoDetailed = [
// Section A
{
  code: 'A1',
  name: 'Compenso artista/"collettivo" sul quale è incentrato il progetto (min 10% del costo totale del progetto)',
  amount: 6000
}, {
  code: 'A2',
  name: 'Compenso altre figure artistiche, personale tecnico e management',
  amount: 12000
}, {
  code: 'A3',
  name: 'Spese di viaggio, vitto, alloggio relative ad artisti, personale tecnico e management',
  amount: 3000
}, {
  code: 'A4',
  name: 'Noleggio/acquisto di attrezzature tecniche e spese per locazione spazi',
  amount: 5000
}, {
  code: 'A5',
  name: "Altri eventuali costi di produzione dell'opera",
  amount: 4000
}, {
  code: 'A6',
  name: "Costi per la distribuzione dell'opera",
  amount: 2000
}, {
  code: 'A7',
  name: "Diritti d'autore",
  amount: 1500
}, {
  code: 'A8',
  name: 'Costi per eventuale fideiussione (art. 12 del Bando)',
  amount: 500
}, {
  code: 'A9',
  name: 'Compenso revisore legale dei conti (art. 11 del Bando)',
  amount: 2000
}, {
  type: 'total',
  name: 'A. TOTALE SPESE DI PRODUZIONE',
  amount: 36000
},
// Section B
{
  code: 'B1',
  name: 'Ufficio stampa',
  amount: 1500
}, {
  code: 'B2',
  name: 'Spese per acquisto spazi pubblicitari (stampa, radio, tv)',
  amount: 1000
}, {
  code: 'B3',
  name: 'Web marketing e Social media marketing',
  amount: 1500
}, {
  code: 'B4',
  name: 'Spese per realizzazione di altro materiale promozionale',
  amount: 1000
}, {
  code: 'B5',
  name: "Spese per eventuali eventi di presentazione dell'opera",
  amount: 500
}, {
  code: 'B6',
  name: 'Spese di viaggio, vitto, alloggio per attività promozionali (artisti, management, uff. stampa)',
  amount: 500
}, {
  type: 'total',
  name: 'B. TOTALE SPESE DI PROMOZIONE E COMUNICAZIONE',
  amount: 6000
},
// Section C
{
  type: 'total',
  name: 'C. TOTALE SPESE GENERALI (max 20% del costo totale del progetto)',
  amount: 8000
}];
const ammissibilitaCriteria = ['Data di costituzione anteriore di almeno 3...', 'Soggetto Proponente con sede legale in Ita...', 'Certificato di attribuzione partita iva.', 'Visura camerale o atto costitutivo e statuto...', 'Svolgimento di attività professionale nel se...', 'Documento di identità Legale Rappresenta...', 'Dichiarazione sullo stato dei pagamenti pe...', 'Materiali (progetti, immagini, brani musical...', 'Opera Inedita'];
const soggettoProponente = {
  denominazione: 'Associazione Culturale Test Nuove Opere',
  formaGiuridica: 'Società a responsabilità limitata - S.R.L.',
  dataCostituzione: '15/03/2015',
  indirizzoSedeLegale: 'Via Roma 1',
  citta: 'Roma',
  regione: 'Lazio',
  provincia: 'RM',
  cap: '00100',
  residenzaSedeLegale: 'Italia',
  partitaIva: '12345678901',
  codiceFiscale: 'RSSMRA90A01H501Z',
  rappresentanteLegale: {
    nome: 'Mario',
    cognome: 'Verdi',
    codiceFiscale: 'RSSMRA90A01H501Z',
    telefono: '+39 333 1234567',
    email: 'bando3.mario.verdi@yopmail.com',
    dataScadenzaDocumento: '01/01/2028'
  },
  contatto: {
    email: 'bando3.mario.verdi@yopmail.com',
    pec: 'pec.mario.verdi@yopmail.com',
    telefono: '+39 333 1234567',
    sitoWeb: '',
    socialNetwork: ''
  }
};
type TabId = 'sintesi' | 'proposta' | 'cronoprogramma' | 'voci_costo' | 'soggetto' | 'ammissibilita' | 'assegnatari' | 'note' | 'variazioni' | 'correzioni';
const tabs: {
  id: TabId;
  label: string;
}[] = [{
  id: 'sintesi',
  label: 'Sintesi'
}, {
  id: 'proposta',
  label: 'Proposta Progettuale'
}, {
  id: 'cronoprogramma',
  label: 'Cronoprogramma'
}, {
  id: 'voci_costo',
  label: 'Voci di costo'
}, {
  id: 'soggetto',
  label: 'Soggetto proponente'
}, {
  id: 'ammissibilita',
  label: 'Ammissibilità'
}, {
  id: 'assegnatari',
  label: 'Assegnatari'
}, {
  id: 'note',
  label: 'Note generali'
}, {
  id: 'variazioni',
  label: 'Variazioni'
}, {
  id: 'correzioni',
  label: 'Correzioni'
}];
function formatCurrency(value: number): string {
  return new Intl.NumberFormat('it-IT', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value) + ' €';
}
function AccordionSection({
  title,
  children,
  defaultOpen = true
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div style={{
    marginBottom: '24px'
  }} data-id="element-572">
      <div className="flex justify-between items-center" style={{
      marginBottom: isOpen ? '16px' : '0'
    }} data-id="element-573">
        <h3 style={{
        fontSize: '18px',
        fontWeight: 500,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-574">
          {title}
        </h3>
        <button type="button" onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-1" style={{
        color: '#2A97DF',
        fontSize: '14px',
        fontFamily: 'Roboto, sans-serif',
        background: 'none',
        border: 'none',
        cursor: 'pointer'
      }} data-id="element-575">
          {isOpen ? 'Vedi meno' : 'Vedi più'}
          {isOpen ? <ChevronUpIcon size={16} data-id="element-576" /> : <ChevronDownIcon size={16} data-id="element-577" />}
        </button>
      </div>
      {isOpen && children}
    </div>;
}
function ReadOnlyField({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div style={{
    marginBottom: '16px'
  }} data-id="element-578">
      <label style={{
      fontSize: '13px',
      color: '#80858E',
      fontFamily: 'Roboto, sans-serif',
      display: 'block',
      marginBottom: '4px'
    }} data-id="element-579">
        {label}
      </label>
      <div style={{
      padding: '12px 16px',
      backgroundColor: '#F4F4F4',
      fontSize: '14px',
      color: '#444444',
      fontFamily: 'Roboto, sans-serif',
      borderRadius: '8px'
    }} data-id="element-580">
        {value || '-'}
      </div>
    </div>;
}
export function CandidaturaDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState<TabId>('sintesi');
  return <div className="space-y-6" data-id="element-581">
      {/* Header Card */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '24px 32px'
    }} data-id="element-582">
        <div className="flex justify-between items-center" data-id="element-583">
          <h1 style={{
          fontSize: '28px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: 'Roboto, sans-serif',
          margin: 0
        }} data-id="element-584">
            Candidatura N. {candidaturaData.id}
          </h1>
          <div className="flex gap-3" data-id="element-585">
            <Button variant="outlined" style={{
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '13px',
            letterSpacing: '0.5px',
            borderRadius: '9999px',
            borderColor: '#E4E4E4',
            color: '#80858E'
          }} data-id="element-586">
              Revoca
            </Button>
            <Button variant="primary" style={{
            backgroundColor: '#2A97DF',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '13px',
            letterSpacing: '0.5px',
            borderRadius: '9999px'
          }} data-id="element-587">
              Rimetti in verifica di ammissibilità
            </Button>
            <Button variant="outlined" style={{
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '13px',
            letterSpacing: '0.5px',
            borderRadius: '9999px'
          }} data-id="element-588">
              Stampa proposta PDF
            </Button>
          </div>
        </div>
      </div>

      {/* Tabs Bar - Separate Card */}
      <div className="bg-white px-8" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderBottom: '1px solid #E4E4E4'
    }} data-id="element-589">
        <div className="flex gap-0 overflow-x-auto" data-id="element-590">
          {tabs.map(tab => <button key={tab.id} type="button" onClick={() => setActiveTab(tab.id)} className="relative pb-3 pt-4 px-4 whitespace-nowrap transition-colors" style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '14px',
          fontWeight: activeTab === tab.id ? 500 : 400,
          color: activeTab === tab.id ? '#2A3A54' : 'rgba(71, 80, 95, 0.7)',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-591">
              {tab.label}
              {activeTab === tab.id && <span className="absolute bottom-0 left-0 right-0" style={{
            height: '2px',
            backgroundColor: '#2A97DF'
          }} data-id="element-592" />}
            </button>)}
        </div>
      </div>

      {/* Tab Content - Separate Cards */}

      {/* Sintesi Tab */}
      {activeTab === 'sintesi' && <>
          {/* Timeline Card */}
          <div className="bg-white" style={{
        borderRadius: '8px',
        boxShadow: 'none',
        border: '1px solid #E4E4E4',
        overflow: 'hidden'
      }} data-id="element-593">
            {/* Blue progress bar at top */}
            <div style={{
          height: '4px',
          backgroundColor: '#2A97DF',
          width: '100%'
        }} data-id="element-594" />
            <div style={{
          padding: '24px 32px'
        }} data-id="element-595">
              <h3 style={{
            fontSize: '18px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            marginBottom: '24px'
          }} data-id="element-596">
                Timeline
              </h3>
              <div className="flex items-center justify-between" data-id="element-597">
                {timelineSteps.map((step, index) => <div key={step.number} className="flex items-center flex-1" data-id="element-598">
                    <div className="flex flex-col items-center" data-id="element-599">
                      <div className="flex items-center justify-center" style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: step.completed ? '#2A97DF' : '#E4E4E4',
                  color: step.completed ? 'white' : '#80858E',
                  fontSize: '14px',
                  fontWeight: 500,
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-600">
                        {step.number}
                      </div>
                      <div style={{
                  marginTop: '8px',
                  textAlign: 'center'
                }} data-id="element-601">
                        <div style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: step.active ? '#2A97DF' : '#444444',
                    fontFamily: 'Roboto, sans-serif',
                    textTransform: 'uppercase'
                  }} data-id="element-602">
                          {step.label}
                        </div>
                        {step.sublabel && <div style={{
                    fontSize: '10px',
                    color: step.completed ? '#2A97DF' : '#80858E',
                    fontFamily: 'Roboto, sans-serif',
                    marginTop: '2px'
                  }} data-id="element-603">
                            {step.sublabel}
                          </div>}
                      </div>
                    </div>
                    {index < timelineSteps.length - 1 && <div className="flex-1 mx-2" style={{
                height: '4px',
                backgroundColor: step.completed && timelineSteps[index + 1].completed ? '#2A97DF' : '#E4E4E4',
                marginTop: '-24px'
              }} data-id="element-604" />}
                  </div>)}
              </div>
            </div>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-605">
            {/* Bando Card */}
            <div className="bg-white" style={{
          border: '1px solid #E4E4E4',
          borderRadius: '8px',
          boxShadow: 'none'
        }} data-id="element-606">
              <div style={{
            position: 'relative'
          }} data-id="element-607">
                <img src={candidaturaData.image} alt={candidaturaData.bando} style={{
              width: '100%',
              height: '180px',
              objectFit: 'cover'
            }} data-id="element-608" />
                {/* Gradient overlay */}
                <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '100%',
              background: 'linear-gradient(0deg, rgb(0, 0, 0) 0%, rgba(102, 102, 102, 0) 30%)'
            }} data-id="element-609" />
                <div style={{
              position: 'absolute',
              bottom: '8px',
              left: '8px',
              backgroundColor: '#E96E00',
              color: 'white',
              padding: '4px 12px',
              fontSize: '12px',
              fontWeight: 500,
              fontFamily: 'Roboto Condensed, sans-serif',
              borderRadius: '16px',
              zIndex: 1
            }} data-id="element-610">
                  Contributo Non Assegnato
                </div>
              </div>
              <div style={{
            padding: '16px'
          }} data-id="element-611">
                <h4 style={{
              fontSize: '16px',
              fontWeight: 500,
              color: '#293B54',
              fontFamily: 'Roboto, sans-serif',
              marginBottom: '16px'
            }} data-id="element-612">
                  {candidaturaData.bando}
                </h4>
                <div style={{
              fontSize: '12px',
              color: '#80858E',
              fontFamily: 'Roboto, sans-serif',
              marginBottom: '16px',
              textTransform: 'uppercase'
            }} data-id="element-613">
                  {candidaturaData.settore}
                </div>
                <Button variant="primary" fullWidth style={{
              backgroundColor: '#293B54',
              borderRadius: '9999px',
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '13px'
            }} data-id="element-614">
                  Dettaglio del bando
                </Button>
              </div>
            </div>

            {/* Contributo Richiesto Card */}
            <div className="bg-white" style={{
          border: '1px solid #E4E4E4',
          borderRadius: '8px',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: 'none'
        }} data-id="element-615">
              <h4 style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            marginBottom: '24px'
          }} data-id="element-616">
                Contributo richiesto
              </h4>
              <div style={{
            position: 'relative',
            width: '160px',
            height: '160px'
          }} data-id="element-617">
                <svg viewBox="0 0 160 160" style={{
              transform: 'rotate(-90deg)'
            }} data-id="element-618">
                  <circle cx="80" cy="80" r="60" fill="none" stroke="#E4E4E4" strokeWidth="20" data-id="element-619" />
                  <circle cx="80" cy="80" r="60" fill="none" stroke="#2A97DF" strokeWidth="20" strokeDasharray={`${candidaturaData.contributoRichiesto / candidaturaData.costoTotale * 377} 377`} data-id="element-620" />
                </svg>
                <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center'
            }} data-id="element-621">
                  <div style={{
                fontSize: '24px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-622">
                    {formatCurrency(candidaturaData.contributoRichiesto).replace(' €', '€')}
                  </div>
                  <div style={{
                fontSize: '12px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-623">
                    Totale contributo
                  </div>
                </div>
              </div>
            </div>

            {/* Distribuzione Voci di Costo Card */}
            <div className="bg-white" style={{
          border: '1px solid #E4E4E4',
          borderRadius: '8px',
          padding: '24px',
          boxShadow: 'none'
        }} data-id="element-624">
              <h4 style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            marginBottom: '8px'
          }} data-id="element-625">
                Distribuzione voci di costo
              </h4>
              <div style={{
            marginBottom: '16px'
          }} data-id="element-626">
                <div style={{
              fontSize: '12px',
              color: '#80858E',
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-627">
                  Totale
                </div>
                <div style={{
              fontSize: '24px',
              fontWeight: 500,
              color: '#293B54',
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-628">
                  {formatCurrency(candidaturaData.costoTotale).replace(' €', '€')}
                </div>
              </div>
              {/* Divider */}
              <div style={{
            height: '1px',
            backgroundColor: '#E4E4E4',
            marginBottom: '16px'
          }} data-id="element-629" />
              <div style={{
            marginBottom: '12px'
          }} data-id="element-630">
                <div style={{
              fontSize: '13px',
              color: '#444444',
              fontFamily: 'Roboto, sans-serif',
              marginBottom: '4px'
            }} data-id="element-631">
                  Spese di produzione
                </div>
                <div style={{
              fontSize: '18px',
              fontWeight: 500,
              color: '#293B54',
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-632">
                  36.000€
                </div>
                <div style={{
              height: '4px',
              backgroundColor: '#2A97DF',
              width: '72%',
              marginTop: '4px'
            }} data-id="element-633" />
              </div>
              <div style={{
            marginBottom: '12px'
          }} data-id="element-634">
                <div style={{
              fontSize: '13px',
              color: '#444444',
              fontFamily: 'Roboto, sans-serif',
              marginBottom: '4px'
            }} data-id="element-635">
                  Spese di promozione e comunicazione
                </div>
                <div style={{
              fontSize: '18px',
              fontWeight: 500,
              color: '#293B54',
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-636">
                  6.000€
                </div>
                <div style={{
              height: '4px',
              backgroundColor: '#98C3EC',
              width: '12%',
              marginTop: '4px'
            }} data-id="element-637" />
              </div>
              <div data-id="element-638">
                <div style={{
              fontSize: '13px',
              color: '#444444',
              fontFamily: 'Roboto, sans-serif',
              marginBottom: '4px'
            }} data-id="element-639">
                  Spese generali
                </div>
                <div style={{
              fontSize: '18px',
              fontWeight: 500,
              color: '#293B54',
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-640">
                  8.000€
                </div>
                <div style={{
              height: '4px',
              backgroundColor: '#D7EDFF',
              width: '16%',
              marginTop: '4px'
            }} data-id="element-641" />
              </div>
            </div>
          </div>
        </>}

      {/* Other tabs - wrapped in their own card */}
      {activeTab !== 'sintesi' && <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4'
    }} data-id="element-642">
          <div className="p-8" data-id="element-643">
            {/* Proposta Progettuale Tab */}
            {activeTab === 'proposta' && <div data-id="element-644">
                <AccordionSection title="Curriculum del soggetto proponente" defaultOpen={false} data-id="element-645">
                  <div style={{
              marginBottom: '16px'
            }} data-id="element-646">
                    <label style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                display: 'block',
                marginBottom: '8px'
              }} data-id="element-647">
                      Descrizione del curriculum del soggetto proponente
                    </label>
                    <div style={{
                padding: '16px',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.6
              }} data-id="element-648">
                      Esperienza pluriennale nel settore musicale.
                    </div>
                  </div>
                  <div data-id="element-649">
                    <label style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                display: 'block',
                marginBottom: '8px'
              }} data-id="element-650">
                      Opere realizzate dal soggetto proponente
                    </label>
                    <div style={{
                padding: '16px',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.6
              }} data-id="element-651">
                      Varie produzioni musicali dal 2015.
                    </div>
                  </div>
                </AccordionSection>

                <AccordionSection title="Progetto di produzione della nuova opera" defaultOpen={false} data-id="element-652">
                  <ReadOnlyField label="Titolo del progetto" value="Progetto Test Nuove Opere Musicali" data-id="element-653" />
                  <div style={{
              marginBottom: '16px'
            }} data-id="element-654">
                    <label style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                display: 'block',
                marginBottom: '8px'
              }} data-id="element-655">
                      Descrizione delle attività di produzione della nuova opera
                    </label>
                    <div style={{
                padding: '16px',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.6,
                minHeight: '100px'
              }} data-id="element-656">
                      Progetto di produzione di nuove opere musicali
                      contemporanee.
                    </div>
                  </div>
                </AccordionSection>

                <AccordionSection title="Curriculum dell'artista/degli artisti proposto/i" defaultOpen={false} data-id="element-657">
                  <div style={{
              marginBottom: '16px'
            }} data-id="element-658">
                    <label style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                display: 'block',
                marginBottom: '8px'
              }} data-id="element-659">
                      Artisti singoli
                    </label>
                    <div style={{
                padding: '16px',
                border: '1px solid #E4E4E4',
                borderRadius: '8px'
              }} data-id="element-660">
                      <div style={{
                  fontSize: '14px',
                  color: '#444444',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-661">
                        Artista 1
                      </div>
                    </div>
                  </div>
                </AccordionSection>

                <AccordionSection title="Progetto di comunicazione" defaultOpen={false} data-id="element-662">
                  <div style={{
              marginBottom: '16px'
            }} data-id="element-663">
                    <label style={{
                fontSize: '13px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                display: 'block',
                marginBottom: '8px'
              }} data-id="element-664">
                      Descrizione delle attività di comunicazione e promozione
                      previste
                    </label>
                    <div style={{
                padding: '16px',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.6
              }} data-id="element-665">
                      Promozione tramite social media e stampa
                    </div>
                  </div>
                </AccordionSection>

                <AccordionSection title="Dichiarazione del soggetto proponente" defaultOpen={false} data-id="element-666">
                  <div style={{
              padding: '16px',
              border: '1px solid #E4E4E4',
              borderRadius: '8px',
              fontSize: '14px',
              color: '#444444',
              fontFamily: 'Roboto, sans-serif',
              lineHeight: 1.6,
              backgroundColor: '#F4F4F4',
              minHeight: '100px'
            }} data-id="element-667">
                    Il soggetto proponente dichiara, ai sensi degli artt. 46 e
                    47 del D.P.R. 28 dicembre 2000, n. 445, consapevole delle
                    sanzioni penali previste dall'art. 76 del medesimo D.P.R.
                    per le ipotesi di falsità in atti e dichiarazioni mendaci,
                    che tutti i dati e le informazioni fornite nella presente
                    candidatura sono veritieri e conformi alla documentazione in
                    possesso del soggetto proponente.
                  </div>
                </AccordionSection>
              </div>}

            {/* Cronoprogramma Tab */}
            {activeTab === 'cronoprogramma' && <div data-id="element-668">
                <div style={{
            padding: '16px 20px',
            backgroundColor: '#D7EDFF',
            marginBottom: '24px',
            fontSize: '14px',
            color: '#444444',
            fontFamily: 'Roboto, sans-serif',
            lineHeight: 1.6
          }} data-id="element-669">
                  Tutte le attività previste dai progetti potranno realizzarsi a
                  partire dalla data di pubblicazione del Bando (15.09.2025) e
                  dovranno concludersi entro e non oltre il 28.02.2027. La
                  pubblicazione o presentazione/esecuzione in pubblico delle
                  nuove opere dovrà avvenire non prima del 02.03.2026.
                </div>
                <table className="w-full" style={{
            borderCollapse: 'collapse'
          }} data-id="element-670">
                  <thead data-id="element-671">
                    <tr style={{
                backgroundColor: '#F4F4F4'
              }} data-id="element-672">
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  borderBottom: '1px solid #E4E4E4'
                }} data-id="element-673">
                        ATTIVITÀ
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  borderBottom: '1px solid #E4E4E4',
                  width: '150px'
                }} data-id="element-674">
                        DA
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  borderBottom: '1px solid #E4E4E4',
                  width: '150px'
                }} data-id="element-675">
                        A
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-676">
                    {cronoprogramma.map((row, index) => <tr key={index} style={{
                borderBottom: '1px solid #E4E4E4'
              }} data-id="element-677">
                        <td style={{
                  padding: '14px 16px',
                  fontSize: '14px',
                  color: '#444444',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-678">
                          {row.attivita}
                        </td>
                        <td style={{
                  padding: '14px 16px',
                  fontSize: '14px',
                  color: '#2A97DF',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-679">
                          {row.da}
                        </td>
                        <td style={{
                  padding: '14px 16px',
                  fontSize: '14px',
                  color: '#2A97DF',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-680">
                          {row.a}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>}

            {/* Voci di Costo Tab */}
            {activeTab === 'voci_costo' && <div data-id="element-681">
                <table className="w-full" style={{
            borderCollapse: 'collapse'
          }} data-id="element-682">
                  <thead data-id="element-683">
                    <tr style={{
                backgroundColor: '#293B54'
              }} data-id="element-684">
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase'
                }} data-id="element-685">
                        NOME
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'right',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  width: '150px'
                }} data-id="element-686">
                        SPESA
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-687">
                    {vociDiCostoDetailed.map((row, index) => {
                const isTotal = row.type === 'total';
                return <tr key={index} style={{
                  borderBottom: '1px solid #E4E4E4',
                  backgroundColor: isTotal ? '#F4F4F4' : 'transparent'
                }} data-id="element-688">
                          <td style={{
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: isTotal ? '#293B54' : '#444444',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: isTotal ? 700 : 400
                  }} data-id="element-689">
                            {isTotal ? row.name : `${row.code}. ${row.name}`}
                          </td>
                          <td style={{
                    padding: '12px 16px',
                    textAlign: 'right',
                    fontSize: '14px',
                    color: isTotal ? '#293B54' : '#2A97DF',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: isTotal ? 700 : 400
                  }} data-id="element-690">
                            {formatCurrency(row.amount)}
                          </td>
                        </tr>;
              })}
                  </tbody>
                  <tfoot data-id="element-691">
                    <tr style={{
                backgroundColor: '#F4F4F4'
              }} data-id="element-692">
                      <td style={{
                  padding: '12px 16px',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-693">
                        Contributo Richiesto:{' '}
                        {formatCurrency(candidaturaData.contributoRichiesto)}
                      </td>
                      <td style={{
                  padding: '12px 16px',
                  textAlign: 'right',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif'
                }} data-id="element-694">
                        Costo Totale:{' '}
                        {formatCurrency(candidaturaData.costoTotale)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>}

            {/* Soggetto Proponente Tab */}
            {activeTab === 'soggetto' && <div data-id="element-695">
                <AccordionSection title="Soggetto Proponente" defaultOpen={false} data-id="element-696">
                  <ReadOnlyField label="Denominazione Soggetto Proponente" value={soggettoProponente.denominazione} data-id="element-697" />
                  <ReadOnlyField label="Forma Giuridica" value={soggettoProponente.formaGiuridica} data-id="element-698" />
                  <ReadOnlyField label="Data di costituzione" value={soggettoProponente.dataCostituzione} data-id="element-699" />
                  <ReadOnlyField label="Indirizzo sede legale" value={soggettoProponente.indirizzoSedeLegale} data-id="element-700" />
                  <div className="grid grid-cols-2 gap-4" data-id="element-701">
                    <ReadOnlyField label="Città" value={soggettoProponente.citta} data-id="element-702" />
                    <ReadOnlyField label="Regione" value={soggettoProponente.regione} data-id="element-703" />
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-704">
                    <ReadOnlyField label="Provincia" value={soggettoProponente.provincia} data-id="element-705" />
                    <ReadOnlyField label="CAP" value={soggettoProponente.cap} data-id="element-706" />
                  </div>
                  <ReadOnlyField label="Residenza sede legale" value={soggettoProponente.residenzaSedeLegale} data-id="element-707" />
                  <ReadOnlyField label="Partita IVA" value={soggettoProponente.partitaIva} data-id="element-708" />
                  <ReadOnlyField label="Codice fiscale del soggetto proponente" value={soggettoProponente.codiceFiscale} data-id="element-709" />
                </AccordionSection>
                <AccordionSection title="Rappresentante Legale" defaultOpen={false} data-id="element-710">
                  <div className="grid grid-cols-2 gap-4" data-id="element-711">
                    <ReadOnlyField label="Nome" value={soggettoProponente.rappresentanteLegale.nome} data-id="element-712" />
                    <ReadOnlyField label="Cognome" value={soggettoProponente.rappresentanteLegale.cognome} data-id="element-713" />
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-714">
                    <ReadOnlyField label="Codice fiscale" value={soggettoProponente.rappresentanteLegale.codiceFiscale} data-id="element-715" />
                    <ReadOnlyField label="Telefono" value={soggettoProponente.rappresentanteLegale.telefono} data-id="element-716" />
                  </div>
                  <ReadOnlyField label="Email" value={soggettoProponente.rappresentanteLegale.email} data-id="element-717" />
                  <ReadOnlyField label="Data scadenza documento d'identità" value={soggettoProponente.rappresentanteLegale.dataScadenzaDocumento} data-id="element-718" />
                </AccordionSection>
                <AccordionSection title="Informazioni di Contatto" defaultOpen={false} data-id="element-719">
                  <ReadOnlyField label="Email" value={soggettoProponente.contatto.email} data-id="element-720" />
                  <ReadOnlyField label="PEC" value={soggettoProponente.contatto.pec} data-id="element-721" />
                  <ReadOnlyField label="Telefono" value={soggettoProponente.contatto.telefono} data-id="element-722" />
                  <ReadOnlyField label="Sito Web" value={soggettoProponente.contatto.sitoWeb} data-id="element-723" />
                  <ReadOnlyField label="Social Network" value={soggettoProponente.contatto.socialNetwork} data-id="element-724" />
                </AccordionSection>
              </div>}

            {/* Ammissibilità Tab */}
            {activeTab === 'ammissibilita' && <div data-id="element-725">
                <div style={{
            padding: '16px 20px',
            backgroundColor: '#D7EDFF',
            marginBottom: '24px',
            fontSize: '14px',
            color: '#444444',
            fontFamily: 'Roboto, sans-serif',
            lineHeight: 1.6
          }} data-id="element-726">
                  Il soggetto proponente ha inviato anche un'altra candidatura:{' '}
                  <strong data-id="element-727">
                    <a href="#" className="text-[#2A97DF] hover:underline" data-id="element-728">
                      vai alla candidatura (202501055363)
                    </a>
                  </strong>
                </div>
                <table className="w-full" style={{
            borderCollapse: 'collapse'
          }} data-id="element-729">
                  <thead data-id="element-730">
                    <tr style={{
                backgroundColor: '#293B54'
              }} data-id="element-731">
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase'
                }} data-id="element-732">
                        CRITERIO
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  width: '150px'
                }} data-id="element-733">
                        NOTE
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  width: '180px'
                }} data-id="element-734">
                        STATO
                      </th>
                      <th style={{
                  padding: '12px 16px',
                  textAlign: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  color: 'white',
                  fontFamily: 'Roboto, sans-serif',
                  textTransform: 'uppercase',
                  width: '150px'
                }} data-id="element-735">
                        AZIONI
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-736">
                    {ammissibilitaCriteria.map((criterion, index) => <tr key={index} style={{
                borderBottom: '1px solid #E4E4E4'
              }} data-id="element-737">
                        <td style={{
                  padding: '14px 16px',
                  fontSize: '14px',
                  color: '#444444',
                  fontFamily: 'Roboto, sans-serif',
                  maxWidth: '300px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }} title={criterion} data-id="element-738">
                          {criterion}
                        </td>
                        <td style={{
                  padding: '14px 16px'
                }} data-id="element-739">
                          <div className="flex items-center gap-2 text-[#80858E] text-[13px]" data-id="element-740">
                            <span data-id="element-741">Nessuna nota</span>
                            <button className="text-[#2A97DF] hover:text-[#0E74B8]" data-id="element-742">
                              <Icon icon="tabler:pencil" fontSize={16} data-id="element-743" />
                            </button>
                          </div>
                        </td>
                        <td style={{
                  padding: '14px 16px'
                }} data-id="element-744">
                          <div className="relative" data-id="element-745">
                            <div className="absolute left-3 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-gray-400" data-id="element-746"></div>
                            <select className="w-full h-8 pl-7 pr-2 border border-gray-300 rounded text-sm text-gray-700 focus:outline-none focus:border-[#2A97DF]" defaultValue="in_valutazione" data-id="element-747">
                              <option value="in_valutazione" data-id="element-748">
                                In Valutazione
                              </option>
                              <option value="ammesso" data-id="element-749">Ammesso</option>
                              <option value="non_ammesso" data-id="element-750">Non Ammesso</option>
                            </select>
                          </div>
                        </td>
                        <td style={{
                  padding: '14px 16px',
                  textAlign: 'center'
                }} data-id="element-751">
                          <Button variant="outlined" size="sm" style={{
                    fontSize: '11px',
                    height: '32px'
                  }} data-id="element-752">
                            Vai al dettaglio
                          </Button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>}

            {/* Assegnatari Tab */}
            {activeTab === 'assegnatari' && <div style={{
          padding: '24px'
        }} data-id="element-753">
                <div className="mb-2" data-id="element-754">
                  <label style={{
              fontSize: '14px',
              color: '#293B54',
              fontWeight: 500,
              fontFamily: 'Roboto, sans-serif'
            }} data-id="element-755">
                    Admin assegnato
                  </label>
                </div>
                <select style={{
            width: '300px',
            height: '40px',
            border: '1px solid #E4E4E4',
            borderRadius: '9999px',
            padding: '0 12px',
            fontSize: '14px',
            color: '#444444',
            fontFamily: 'Roboto, sans-serif',
            outline: 'none'
          }} defaultValue="" data-id="element-756">
                  <option value="" disabled data-id="element-757">
                    Seleziona admin...
                  </option>
                  <option value="admin1" data-id="element-758">Mario Rossi</option>
                  <option value="admin2" data-id="element-759">Luigi Verdi</option>
                </select>
              </div>}

            {/* Note Generali Tab */}
            {activeTab === 'note' && <div style={{
          padding: '24px'
        }} data-id="element-760">
                <div className="space-y-6" data-id="element-761">
                  <div data-id="element-762">
                    <label className="block mb-2" style={{
                fontSize: '14px',
                color: '#293B54',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-763">
                      Note Generali Admin
                    </label>
                    <textarea placeholder="Inserisci le note generali..." style={{
                width: '100%',
                height: '150px',
                border: '1px solid #E4E4E4',
                borderRadius: '24px',
                padding: '12px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                resize: 'vertical',
                outline: 'none'
              }} data-id="element-764" />
                  </div>
                  <div data-id="element-765">
                    <label className="block mb-2" style={{
                fontSize: '14px',
                color: '#293B54',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-766">
                      Note per Verbali
                    </label>
                    <textarea placeholder="Inserisci le note per i verbali..." style={{
                width: '100%',
                height: '150px',
                border: '1px solid #E4E4E4',
                borderRadius: '24px',
                padding: '12px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                resize: 'vertical',
                outline: 'none'
              }} data-id="element-767" />
                  </div>
                  <div data-id="element-768">
                    <label className="block mb-2" style={{
                fontSize: '14px',
                color: '#293B54',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-769">
                      Note Generali Valutatori
                    </label>
                    <textarea placeholder="Inserisci le note dei valutatori..." style={{
                width: '100%',
                height: '150px',
                border: '1px solid #E4E4E4',
                borderRadius: '24px',
                padding: '12px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                resize: 'vertical',
                outline: 'none'
              }} data-id="element-770" />
                  </div>
                  <div className="flex justify-end" data-id="element-771">
                    <Button variant="primary" style={{
                backgroundColor: '#293B54',
                fontFamily: 'Roboto Condensed, sans-serif',
                fontSize: '14px',
                padding: '8px 24px'
              }} data-id="element-772">
                      Salva note
                    </Button>
                  </div>
                </div>
              </div>}

            {/* Variazioni Tab */}
            {activeTab === 'variazioni' && <div style={{
          minHeight: '200px'
        }} data-id="element-773"></div>}

            {/* Correzioni Tab */}
            {activeTab === 'correzioni' && <div style={{
          minHeight: '200px'
        }} data-id="element-774"></div>}
          </div>
        </div>}
    </div>;
}